import { useMemo } from 'react';
import { filter, isEmpty, map } from 'lodash';
import useFindAllIdCards from '../../screens/HomeScreen/context/hooks/useFindAllIdCards';
import RecommendationInput from '../RecommendationInput';

const ModuleTypeRecommendationInput = ({ value, onChange, isDisabled }) => {
  const { idCards, isLoading } = useFindAllIdCards();

  let moduleIdCards = idCards && filter(idCards, (value) => !value.fpso);
  const recommendations = useMemo(() => (!moduleIdCards ? [] : moduleIdCards.map((idCard) => idCard.name)), [idCards]);
  const _onChange = (name, isRecommendationClick) => {
    if (isRecommendationClick) {
      const card = idCards.find((c) => c.name === name);
      onChange(card, isRecommendationClick);
    } else {
      onChange(name, isRecommendationClick);
    }
  };

  return (
    <RecommendationInput
      recommendations={recommendations}
      value={value}
      placeholder='Module Name'
      onChange={_onChange}
      isDisabled={isDisabled}
    />
  );
};

export default ModuleTypeRecommendationInput;
